import React from 'react';
import { Container, Jumbotron } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { Route } from 'react-router-dom';
import { AppState } from 'reducers';

interface ConditionalRouteProps {
    name: string;
    isOrdersServiceDisabled: boolean;
    disableTime: string;
    disableMessage: string;
    viewVisibilityCondition: boolean;
    view: JSX.Element;
    path?: string;
}

const ConditionalRoute = ({ name, isOrdersServiceDisabled, disableTime, disableMessage, viewVisibilityCondition, view, path }: ConditionalRouteProps) => {
    const exceptionalRoutes = useSelector((state: AppState) => state.data.userInfo.servicesAvailableDuringServiceWork);

    return (
        <Route
            path={path}
            render={() => (isOrdersServiceDisabled && !exceptionalRoutes.includes(name) ? (
                <Jumbotron className='App-disabled'>
                    <Container>
                        <h1>System zamówień online jest niedostępny</h1>
                        <h2>{disableTime}</h2>
                        <span>{disableMessage}</span>
                    </Container>
                </Jumbotron>
            ) : (
                viewVisibilityCondition && view)
            )}
        />
    );
};

export default ConditionalRoute;
